const Emoji_IJK = {
    ':ibdrool': { id: 294, width: 18, height: 29 },
    ':icecream': { id: 295, width: 22, height: 25 },
    ':icon6': { id: 296, width: 19, height: 19 },
    ':idea_1': { id: 297, width: 22, height: 26 },
    ':idea': { id: 298, width: 20, height: 20 },
    ':idiot': { id: 299, width: 20, height: 20 },
    ':image': { id: 588, width: 32, height: 32 },
    ':in_love': { id: 301, width: 20, height: 25 },
    ':info': { id: 300, width: 31, height: 31 },
    ':inlove': { id: 591, width: 18, height: 18 },
    ':ispug': { id: 302, width: 25, height: 22 },
    ':jc': { id: 303, width: 18, height: 18 },
    ':jerk': { id: 304, width: 25, height: 20 },
    ':jester': { id: 305, width: 33, height: 25 },
    ':jockey': { id: 306, width: 20, height: 21 },
    ':jumpy': { id: 307, width: 28, height: 28 },
    ':kamikaze': { id: 308, width: 24, height: 20 },
    ':kar': { id: 309, width: 40, height: 28 },
    ':kenshin2': { id: 310, width: 27, height: 26 },
    ':kicher': { id: 311, width: 15, height: 15 },
    ':kid': { id: 312, width: 20, height: 20 },
    ':king': { id: 313, width: 25, height: 27 },
    ':kiss': { id: 64, width: 18, height: 18 },
    ':kiss1': { id: 314, width: 18, height: 18 },
    ':kisss': { id: 315, width: 36, height: 24 },
    ':kosoy': { id: 316, width: 15, height: 15 },
    ':krider': { id: 317, width: 20, height: 20 },
    ':krilin': { id: 318, width: 20, height: 21 },
    ':kuss': { id: 319, width: 37, height: 18 },
    ':kwasny': { id: 320, width: 18, height: 18 },
}

export default Emoji_IJK
